module.exports = __webpack_public_path__ + "a3effa150bd13f84d6e42e144b4ab096.jpg";


//////////////////
// WEBPACK FOOTER
// ./img/mobile/m-about-img8.jpg
// module id = 218
// module chunks = 4